const data = [
    {
        roles:[
            "Virtual Seller",
            "Sales Manager",
            "Sales Executive",
            "CPQ and Sales Operations",
            "Revenue Management"
        ],
        title: "Oracle Sales Website",
        description: "Guide sellers with intelligent recommendations to help them focus on the most valuable prospects at the right time. Built-in AI selling tools and comprehensive customer data from across your business give sellers a CRM they trust and want to use.",
        image: "tbnail-01.png",
        cta_text:"Learn more about Oracle Sales",
        url:"https://www.oracle.com/cx/sales/"
    },
    {
        roles:[
            "Virtual Seller",
            "Sales Manager",
            "Sales Executive",
            "CPQ and Sales Operations",
            "Revenue Management"
        ],
        title: "Video: Oracle Sales",
        description: "Oracle Sales improves sales effectiveness with better planning and forecasting capabilities, intelligent insights to guide sellers to the next best action, self-service quoting and configurations, and ecommerce sites that support any revenue model.",
        image: "tbnail-02.png",
        cta_text:"Explore Oracle Sales",
        url:"https://youtu.be/jms4rbjg3Lk"
    },
    {
        roles:[
            "Head of Digital and Ecommerce"
        ],
        title: "Oracle Commerce Website",
        description: "Move business online and enrich the buying experience with data from your CRM and back-office systems. Oracle Commerce is a unified B2B and B2C ecommerce platform that makes your digital sales channels central to your company’s success by building personalized, online buyer experiences, innovating faster, and boosting sales.",
        image: "tbnail-03.png",
        cta_text:"Learn more about Oracle Commerce",
        url:"https://www.oracle.com/cx/ecommerce/"
    },
   {
        roles:[
            "Head of Digital and Ecommerce"
        ],
        title: "Constellation Research : Oracle Revamps Commerce",
        description: "Explore key market trends and how the right ecommerce solution can help you keep up with rapidly changing buying and selling expectations.",
        image: "tbnail-04.png",
        cta_text:"Download the report",
        url:"https://www.oracle.com/a/ocom/resources/cx-constellation-report-oracle-revamps-cx-commerce.pdf"
    } 
]

export default data;